import api from "../../domain/api";
import {
  GET_PROCESSINGTYPES,
  ADD_PROCESSINGTYPE,
  EDIT_PROCESSINGTYPE,
  GET_PROCESSINGTYPE,
  RESET_PROCESSINGTYPE,
  GET_ALL_PROCESSINGTYPES,
  ERROR_PROCESSINGTYPE,
} from "../types/processingtype_type";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addProcessingtype = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/processingtypes`, formData);
    dispatch({
      type: ADD_PROCESSINGTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getProcessingtypes =
  ({
    termField = "",
    term = "",
    pageNumber = "",
    start_from = "",
    start_to = "",
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_PROCESSINGTYPE,
      });
      const { data } = await api.get(
        `/processingtypes?searchTerm=${termField}&keyword=${term}&pageNumber=${pageNumber}&start_from=${start_from}&start_to=${start_to}`
      );

      dispatch({
        type: GET_PROCESSINGTYPES,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getProcessingtype = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_PROCESSINGTYPE,
    });
    const { data } = await api.get(`/processingtypes/${id}`);

    dispatch({
      type: GET_PROCESSINGTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editProcessingtype = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/processingtypes/${id}`, formData);
    dispatch({
      type: EDIT_PROCESSINGTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteProcessingtype = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/processingtypes/${id}`);
    dispatch(setAlert("Processingtype Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllProcessingtypes = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/processingtypes/all`);

    dispatch({
      type: GET_ALL_PROCESSINGTYPES,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_PROCESSINGTYPE });
};
      